import BodyCard from '@/Components/BodyCard'
import TextLabel from '@/Components/Common/TextLabel'
import HeaderCard from '@/Components/HeaderCard'
import { Input } from '@/Components/ui/input'
import Constant from '@/utils/Constant'
import { format } from 'date-fns'
import { ArrowRight } from 'lucide-react'
import React, { useEffect, useReducer } from 'react'
import { useLoaderData, useNavigate } from 'react-router-dom'

const ViewActivityLog = () => {
    const { activityLog } = useLoaderData()
    const navigate = useNavigate()
    const [event, updateEvent] = useReducer((prev, next) => ({ ...prev, ...next }), {
        activityLog: activityLog,
    })

    useEffect(() => {
        if(!activityLog){
            navigate('/activity-log')
        }
        updateEvent({activityLog})
    }, [activityLog])
    return (
        <div>
            <HeaderCard></HeaderCard>
            <BodyCard>
                <div>
                    <div className="grid grid-cols-5 gap-2">
                        {/* <div>
                            <TextLabel text="Agency" className="text-[13px]" />
                            <Input value={activityLog?.client} disabled={true} className="mt-2 bg-gray-100" />
                        </div> */}
                        <div>
                            <TextLabel text="MR Number" />
                            <Input value={event?.activityLog?.mr_number} disabled={true} className="mt-2 bg-gray-100" />
                        </div>
                        <div>
                            <TextLabel text="Patient Name" />
                            <Input value={event?.activityLog?.patient_name} disabled={true} className="mt-2 bg-gray-100" />
                        </div>
                        <div>
                            <TextLabel text="Payor Type" />
                            <Input value={event?.activityLog?.payor_type} disabled={true} className="mt-2 bg-gray-100" />
                        </div>
                        <div>
                            <TextLabel text="Assessment Type" />
                            <Input value={event?.activityLog?.assessment_type} disabled={true} className="mt-2 bg-gray-100" />
                        </div>
                        <div>
                            <TextLabel text="Arrived Date" />
                            <Input
                                value={event?.activityLog?.arrived_date_custom ? format(event?.activityLog?.arrived_date_custom, Constant.DATE_FORMAT_WITH_TIME_SEPERATED_BY_SLASH) : ''}
                                disabled={true}
                                className="mt-2 bg-gray-100"
                            />
                        </div>
                    </div>
                    <hr className="my-4" />
                    <div>
                        <TextLabel text={'Activity Log'} />
                        <div className="ps-5 mt-2">
                            {event?.activityLog?.activity && event?.activityLog?.activity.length
                                ? event?.activityLog?.activity.map((activity) => (
                                      <div className="p-3 border-l border-l-gray-400 relative flex items-center">
                                          <div className="size-9 absolute left-[-18px] flex justify-center items-center bg-white">
                                              <div className="size-8 rounded-full flex justify-center items-center  text-white font-bold bg-blue-500">
                                                  {activity.modified_by.charAt(0).toUpperCase()}
                                              </div>
                                          </div>
                                          <div className="flex items-center w-full">
                                              <span className="ms-3 text-[13px] text-gray-500 flex-none">
                                                  {format(activity.change_time, Constant.DATE_FORMAT_WITH_TIME_SEPERATED_BY_SLASH)}
                                              </span>
                                              <div className="bg-gray-100 text-[13px] gap-2 p-3 ms-3 grow rounded-sm">
                                                  <div className="w-full flex gap-1">
                                                      <span className="font-bold text-blue-500">{activity.modified_by} </span>
                                                      {activity.field_name == 'creation' ? (
                                                          <span>Added New Chart</span>
                                                      ) : (
                                                          <div>
                                                              <span>Change <span className='text-green-600 font-bold'>{activity.field_lable}</span> </span>
                                                              <span className='font-bold'> {activity.field_old_value} </span>
                                                              <span> <ArrowRight className='inline text-green-700' size={15} /> </span>
                                                              <span className='font-bold'> {activity.field_new_value}</span>
                                                          </div>
                                                      )}
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  ))
                                : null}
                        </div>
                    </div>
                </div>
            </BodyCard>
        </div>
    )
}

export default ViewActivityLog
